<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="文本">
        <t-input v-model="attribute.chartTitle" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="大小">
        <t-input-number v-model="attribute.titleSize" size="small" :min="2" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.titleLeft" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.titleTop" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.titleTextColor" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="内边距" :expand="false">
      <t-form-item label="内边距(左)">
        <t-input-number size="small" v-model="attribute.gridX" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(上)">
        <t-input-number size="small" v-model="attribute.gridY" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(右)">
        <t-input-number size="small" v-model="attribute.gridX2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(下)">
        <t-input-number size="small" v-model="attribute.gridY2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="x轴">
        <t-switch v-model="attribute.xAxisShow" :label="['开', '关']" size="small"/>
      </t-form-item>
      <div v-show="attribute.xAxisShow">
        <t-form-item label="x轴线显示">
          <t-switch v-model="attribute.xLineShow" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="x轴线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xLineColor" size="small"/>
        </t-form-item>
        <t-form-item label="x轴字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xLabelColor" size="small"/>
        </t-form-item>
        <t-form-item label="x轴网格线">
          <t-switch v-model="attribute.xGridLineShow" :label="['开', '关']" size="small"/>
        </t-form-item>
      </div>
    </e-collapse>
    <e-collapse title="标签" :expand="false">
      <t-form-item label="标签颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yLabelColor" size="small"/>
      </t-form-item>
      <t-form-item label="标签字体">
        <t-input-number v-model="attribute.yLabelSize" :min="2" :max="200" size="small" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="柱体" :expand="false">
      <t-form-item label="柱体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.barColor[0]" size="small"/>
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.barColor[1]" size="small"/>
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number v-model="attribute.barBorderRadius" :min="0" :max="50" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="柱体宽度">
        <t-input-number v-model="attribute.barWidth" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="背景">
        <t-switch v-model="attribute.barBgShow" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="false">
      <t-form-item label="数值显示">
        <t-switch v-model="attribute.barLabelShow" :label="['开', '关']" size="small"/>
      </t-form-item>
      <div v-show="attribute.barLabelShow">
        <t-form-item label="数值字体">
          <t-input-number v-model="attribute.barLabelSize" :min="2" :max="100" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="数值颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.barLabelColor" size="small"/>
        </t-form-item>
        <t-form-item label="数值位置">
          <t-select v-model="attribute.barLabelPosition" size="small">
            <t-option label="顶部" value="top"/>
            <t-option label="左" value="left"/>
            <t-option label="右" value="right"/>
            <t-option label="底部" value="bottom"/>
          </t-select>
        </t-form-item>
        <t-form-item label="数值单位">
          <t-input v-model="attribute.barLabelUnit" size="small" :maxcharacter="20"/>
        </t-form-item>
      </div>
    </e-collapse>
    <t-form-item label="数据排序">
      <t-select v-model="attribute.sort" size="small">
        <t-option label="自定义" value="cus"/>
        <t-option label="升序" value="asc"/>
        <t-option label="降序" value="desc"/>
      </t-select>
    </t-form-item>
    <t-form-item label="开起滚动">
      <t-switch v-model="attribute.enableScroll" :label="['开', '关']" size="small"/>
    </t-form-item>
    <div v-show="attribute.enableScroll">
      <t-form-item label="显示行数">
        <t-input-number v-model="attribute.showLine" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="滚动方式">
        <t-select v-model="attribute.scrollType" size="small">
          <t-option label="单列滚动" value="one"/>
          <t-option label="整列滚动" value="all"/>
        </t-select>
      </t-form-item>
      <t-form-item label="滚动间隔">
        <t-input-number v-model="attribute.scrollTime" :min="1" :max="60" size="small" :decimal-places="0"/>
      </t-form-item>
    </div>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
import EChartPosition from "@/components/designer/e-chart-position";
export default {
  name: "cpt-chart-scroll-list-option",
  components: {EChartPosition,CptData},
  props: {attribute: Object,cptDataForm:Object,},
}
</script>

<style scoped>

</style>
